import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth.jsx";
import { getImagesUrls } from "../utils/s3Utils.js";
import LoadingComponent from "./LoadingComponent.jsx";
import { useImagePreloader } from "../hooks/useImagePreLoader.jsx";
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CoPresentIcon from '@mui/icons-material/CoPresent';
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

//GET URL PRESIGNED OF IMAGES
const imageskeyRoutes = {
  s3logo: "assets/images/nh.png",
  s3delivery: "assets/icons/delivery.png",
  s3delivery2: "assets/icons/delivery2.png",
  s3uploadOrders: "assets/icons/upload.png",
  s3warehouse: "assets/icons/warehouse.png",
  s3home: "assets/icons/home.png",
  s3controlPanel: "assets/icons/control-panel.png",
  s3dashboard: "assets/icons/dashboard.png",
  s3deliveryNH: "assets/icons/delivery_nh.png",
  s3Dots: "assets/icons/dots.png",
};

const imageUrls = await getImagesUrls(imageskeyRoutes, "mobileLayout");
const drawerWidth = 240;

function MobileLayout(props) {
  const navigate = useNavigate();
  const { children } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const { user, logout } = useAuth();
  const { allImagesLoaded, timeoutReached } = useImagePreloader(
    imageUrls,
    2000
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerContent = (
    <div>
      <Toolbar />{" "}
      <List>
        {/* <ListItem disablePadding>
          <ListItemButton
            sx={{
              mt: '2rem',
              py: 2,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <ListItemIcon>
              <CoPresentIcon />
            </ListItemIcon>
            <ListItemText
              className="mobile-list-item"
              primary="Mi cuenta"
              onClick={() => navigate("my-account")}
            />
          </ListItemButton>
        </ListItem> */}
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              mt: '2rem',
              py: 2,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <ListItemIcon>
              <DirectionsCarIcon />
            </ListItemIcon>
            <ListItemText
              className="mobile-list-item"
              primary="Mis Rutas"
              onClick={() => navigate("my-routes")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              py: 2,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText
              className="mobile-list-item"
              primary="Salir"
              onClick={logout}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      {!allImagesLoaded && !timeoutReached ? (
        <LoadingComponent />
      ) : (
        <>
          <Box sx={{ display: "flex" }}>
            <AppBar
              position="fixed"
              elevation={0}
              sx={{
                backgroundColor: "white",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
            >
              <Toolbar>
                <IconButton
                  color="primary"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{
                    ml: 1,
                    height: "3rem !important",
                    borderRadius: "0px !important",
                    fontSize: "2rem !important",
                    border: "0px !important",
                    color: "#00e1be",
                  }}
                >
                  <MenuIcon sx={{ height: "3rem", width: "3rem" }} />
                </IconButton>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="drawer-s3logo">
                    <img
                      src="https://static.wixstatic.com/media/d57788_abb2a20628fb49f892f533e29e46b5cd~mv2.png"
                      alt="Logo NH"
                      style={{ width: "175px", marginTop: "10px" }}
                    />
                  </div>
                </Box>
                <Box sx={{ width: 48, height: 48 }} />
              </Toolbar>
            </AppBar>

            <Drawer
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{ keepMounted: true }}
              sx={{
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
            >
              {drawerContent}
            </Drawer>

            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 3,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
              }}
            >
              <Toolbar />
              {children}
            </Box>
          </Box>
        </>
      )}
    </>
  );
}

export default MobileLayout;
